/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * modules.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * Import module.
 */
import { clickSmoothScrollTo, loadSmoothScrollTo } from "./setSmoothScrollTo";
import { setDrawerButton } from "./setDrawerButton";
import { setModal } from "./setModal";
import { setScrollFlag } from "./setScrollFlag";
import { setGsap } from "./setGsap";
import { setScrollBar } from "./setScrollBar";

/**
 * add modules.
 */
function addModules() {
  let movie = document.getElementById("movie");
  let video = document.getElementById("video");
  const videoPlayState = () => {
    window.addEventListener("scroll", () => {
      let movieTop = movie.getBoundingClientRect().top + window.pageYOffset;
      window.pageYOffset > movieTop - window.innerHeight ? video.play() : video.pause();
    });
  }
  movie && videoPlayState();
}

/**
 * Do modules.
 */
function modules() {
  clickSmoothScrollTo();
  loadSmoothScrollTo();
  setDrawerButton();
  setModal();
  setScrollFlag();
  setGsap();
  addModules();
  setScrollBar();
}

export { modules };
